import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Avatar } from 'antd';
import { Popover } from '@blueprintnyc/bpnyc-common-admin';
import { Logout } from '@blueprintnyc/bpnyc-common-admin/dist/icons';
import { logout } from '../../redux/actions';
import { isSuperAdmin } from '@/redux/util';

import './AvatarMenu.scss';

const AvatarMenu = props => {
	const { adminSSOProfile, logout } = props;
	const navigate = useNavigate();

	const handleClick = item => {
		const { path } = item;
		if (item.name === 'Logout') logout();
		else if (path.charAt(0) === '/') navigate(path);
	};

	const renderMenuItem = (item, idx, isSubItem) => {
		const title = item.name;
		const className = `menu-item ${isSubItem ? 'sub-item' : ''}`;
		if (title === 'Admins' && !isSuperAdmin()) return null;
		return (
			<div
				className={className}
				key={`avatar-menuItem ${title} ${idx}`}
				onClick={() => handleClick(item)}
			>
				{item.icon}
				<span className="menu-title">{title}</span>
			</div>
		);
	};

	const subMenu = [
		// {
		// 	name: 'Admins',
		// 	icon: <Contacts />,
		// 	path: '/admins',
		// },
		{
			name: 'Logout',
			icon: <Logout />,
			path: `/logout`,
		},
	];
	const userItem = adminSSOProfile ? (
		<Popover
			closeOnBackground
			placement="left"
			trigger="hover"
			content={
				<div className="sub-menu">
					{subMenu.map((subitem, idx) => renderMenuItem(subitem, idx, true))}
				</div>
			}
			key={'avatarMenu-userItem'}
		>
			<div className={`menu-item user-item`}>
				<Avatar className="avatar" size={35} src={adminSSOProfile.picture} alt="profile-pic" />
			</div>
		</Popover>
	) : null;

	return <div className="AvatarMenu">{userItem}</div>;
};

const msp = ({ auth }) => ({
	adminSSOProfile: auth.adminSSOProfile,
});

const mdp = dispatch => ({
	logout: () => dispatch(logout()),
});

export default connect(msp, mdp)(AvatarMenu);
